export default {
  ITEM: 'item'
};



// WEBPACK FOOTER //
// ./src/components/ClubCMS/DragItems/DraggableItem/DraggableItemsTypes.js